import { render } from "./groupCall.vue?vue&type=template&id=68bf8027&scoped=true"
import script from "./groupCall.vue?vue&type=script&lang=js"
export * from "./groupCall.vue?vue&type=script&lang=js"

import "./groupCall.vue?vue&type=style&index=0&id=68bf8027&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68bf8027"

export default script